import { Modal, Button } from "react-bootstrap";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faDoorClosed, faExclamationCircle, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

type MessageModalProps = {
    show: boolean;
    title?: React.ReactNode;
    message: React.ReactNode;
    typeMessage: "success" | "danger" | "warning" | "info";
    onClose: () => void;
};

export default function ModalMessage({
    show,
    title,
    message,
    typeMessage,
    onClose,
}: MessageModalProps) {
    return (
        <Modal show={show} onHide={onClose} centered >
            
                <Modal.Header closeButton className="py-2">
                    <Modal.Title >
                        {typeMessage === "success" && (<><FontAwesomeIcon className="text-success" icon={faCheckCircle} />&nbsp;</>)}
                        {typeMessage === "danger" && (<><FontAwesomeIcon className="text-danger" icon={faXmarkCircle} />&nbsp;</>)}
                        {typeMessage === "warning" && (<><FontAwesomeIcon className="text-warning" icon={faExclamationCircle} />&nbsp;</>)}
                        {typeMessage === "info" && (<><FontAwesomeIcon className="text-info" icon={faExclamationCircle} />&nbsp;</>)}

                        {title === "" && (
                            <>
                                {typeMessage === "success" && (<>Sucesso!</>)}
                                {typeMessage === "danger" && (<>Error!</>)}
                                {typeMessage === "warning" && (<>Alerta!</>)}
                                {typeMessage === "info" && (<>Informação</>)}
                            </>
                        )}
                    </Modal.Title>
                </Modal.Header>
            
            <Modal.Body >{message}</Modal.Body>
            <Modal.Footer className="py-1">
                <Button variant="secondary" onClick={onClose}>
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
